import React, {useEffect, useState} from "react";
import {
    Box, Button, Flex, HStack,
    Tag,
    Text,
    VStack,
} from '@chakra-ui/react';
import {format, parseISO} from 'date-fns';

import WebApp from "@twa-dev/sdk";
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import { FaPlus } from "react-icons/fa";


function NotesPage() {
    return (
        <Box maxW="md" mx="auto" mt={6} p={4}>

        </Box>
    );
};


export default NotesPage;
